interface EquipmentCardProps {
    id: string;
    name: string;
    price: number;
    image_url: string;
    status: string;
    quantity?: number;
    availableQuantity?: number;
    onSelect?: (id: string) => void;
    selected?: boolean;
    datesSelected?: boolean;
    userDiscount?: number;
}

export const EquipmentCard = ({
    id,
    name,
    price = 0,
    image_url,
    status,
    quantity = 0,
    availableQuantity,
    onSelect,
    selected = false,
    datesSelected = false,
    userDiscount = 0,
}: EquipmentCardProps) => {
    // Используем скидку прямо из props без дополнительных запросов
    const discount = userDiscount;

    // Вычисляем цену со скидкой только если скидка > 0
    const discountedPrice = discount > 0 
        ? Math.round((price * (100 - discount)) / 100) 
        : price;

    const statusClass: Record<string, string> = {
        available: 'bg-green-100 text-green-800',
        maintenance: 'bg-yellow-100 text-yellow-800',
        booked: 'bg-red-100 text-red-800',
    };

    const statusText: Record<string, string> = {
        available: 'Доступно',
        maintenance: 'На обслуживании',
        booked: 'Забронировано',
    };

    const isBookable = status !== 'maintenance' && !(datesSelected && status === 'booked');

    const isDisabled = !isBookable;

    const handleSelect = () => {
        if (isDisabled) {
            return;
        }

        if (onSelect && id) {
            if (!id || id.trim() === '') {
                console.error('EquipmentCard: Пустой ID');
                return;
            }

            console.log('EquipmentCard: вызываем onSelect с ID:', id, typeof id, 'уже выбрано:', selected);
            onSelect(id);
        } else if (onSelect) {
            console.error('EquipmentCard: Пустой ID:', id);
        }
    };

    return (
        <div className="w-1/2 sm:w-1/3 md:w-1/4 lg:w-1/5 px-2 mb-4">
            <div
                className={`
                    bg-white rounded-lg shadow-sm border h-full overflow-hidden transition
                    ${isDisabled
                        ? 'opacity-70 cursor-not-allowed border-gray-200'
                        : 'hover:shadow-md hover:border-primary-300 cursor-pointer'}
                    ${selected ? 'border-yellow-400 ring-0 ring-yellow-400 bg-yellow-50' : 'border-gray-200'}
                `}
                onClick={handleSelect}
            >
                <div className="relative w-full overflow-hidden" style={{ paddingBottom: "75%" }}>
                    {image_url ? (
                        <div className="absolute inset-0 w-full h-full">
                            <img
                                src={image_url}
                                alt={name}
                                className="absolute inset-0 w-full h-full object-contain rounded-t-lg bg-gray-50 p-1 z-10"
                            />
                            {selected && (
                                <div className="absolute inset-0 w-full h-full bg-yellow-100 opacity-30 z-20 rounded-t-lg"></div>
                            )}
                        </div>
                    ) : (
                        <div className={`absolute inset-0 w-full h-full ${selected ? 'bg-yellow-50' : 'bg-gray-100'} flex items-center justify-center rounded-t-lg`}>
                            <svg className="w-8 h-8 text-gray-300" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z" clipRule="evenodd" />
                            </svg>
                        </div>
                    )}

                    {status === 'maintenance' && (
                        <div className={`absolute top-2 left-2 px-2 py-1 rounded-full text-xs font-medium ${statusClass[status]} z-30`}>
                            {statusText[status]}
                        </div>
                    )}

                    {status === 'booked' && datesSelected && (
                        <div className={`absolute top-2 left-2 px-2 py-1 rounded-full text-xs font-medium ${statusClass[status]} z-30`}>
                            {statusText[status]}
                        </div>
                    )}
                </div>

                <div className="p-2 flex flex-col">
                    <h3 className="text-sm font-medium text-gray-800 line-clamp-2 h-8 overflow-hidden mb-auto">
                        {name}
                    </h3>

                    <div className="mt-1 border-t pt-1 border-gray-100 w-full">
                        <div className="flex items-baseline justify-between">
                            <div className="flex flex-col items-start">
                                {discount > 0 ? (
                                    <>
                                        <span className="text-yellow-500 font-medium">{discountedPrice.toLocaleString()} ₽</span>
                                        <span className="text-gray-400 text-xs line-through">{price.toLocaleString()} ₽</span>
                                    </>
                                ) : (
                                    <span className="text-yellow-500 font-medium">{discountedPrice.toLocaleString()} ₽</span>
                                )}
                                <span className="text-gray-400 text-xs">в день</span>
                            </div>
                            {datesSelected && typeof availableQuantity !== 'undefined' ? (
                                <div className="text-xs font-medium text-gray-800">
                                    {availableQuantity} / {quantity} шт.
                                </div>
                            ) : (
                                quantity > 0 && (
                                    <div className="text-xs font-medium text-gray-800">
                                        {quantity} шт.
                                    </div>
                                )
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};